import { createRouter, createWebHistory } from 'vue-router'
import Login from "@/views/login/login.vue"
import Register from "@/views/register/register.vue"
import UserEdit from "@/views/user-edit/user-edit.vue"
import SecuritySettings from "@/views/security-settings/security-settings.vue"
import SearchPreferences from "@/views/search-preferences/search-preferences.vue"
import SettingsLayout from "@/views/settings-layout/settings-layout.vue"
import NotFound from "@/components/error/404.vue"
import Forbidden from "@/components/error/403.vue"
import Home from "@/views/home/home.vue";
import BookDetail from "@/views/book-detail/book-detail.vue";
import AuthorDetail from "@/views/author-detail/author-detail.vue";
import CategoryDetail from "@/views/category-detail/category-detail.vue";
import ReadingProgress from "@/views/reading-progress/reading-progress.vue";
import BookSuggest from "@/views/book-suggest/book-suggest.vue";
import OldBookList from "@/views/old-book/old-book-list/old-book-list.vue";
import MyOldBookList from "@/views/old-book/my-old-book-list/my-old-book-list.vue";
import OldBookForm from "@/views/old-book/old-book-form/old-book-form.vue";
import OldBookDetail from "@/views/old-book/old-book-detail/old-book-detail.vue";
import BookOldBooks from "@/views/old-book/book-old-books/book-old-books.vue";
import SmartRecommendation from "@/views/smart-recommendation/smart-recommendation.vue";
import Info from "@/views/info/info.vue";

const Authority = {
  GUEST: "ROLE_GUEST",
  ADMIN: 'ROLE_ADMIN',
  STAFF: 'ROLE_STAFF',
  USER: 'ROLE_USER',
}

const router = createRouter({
  history: createWebHistory("/"),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        isLogin: false,
        title: 'Đăng Nhập',
        authorities: [Authority.GUEST]
      },
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        isLogin: false,
        title: 'Đăng Ký',
        authorities: [Authority.GUEST]
      },
    },
    {
      path: '/user-edit',
      name: 'UserEdit',
      component: UserEdit,
      meta: {
        isLogin: true,
        title: 'Cập nhật thông tin',
        authorities: [Authority.USER, Authority.STAFF, Authority.ADMIN]
      },
    },
    {
      path: '/search-preferences',
      name: 'SearchPreferences',
      component: SearchPreferences,
      meta: {
        isLogin: true,
        title: 'Cá nhân hóa tìm kiếm',
        authorities: [Authority.USER, Authority.STAFF, Authority.ADMIN]
      },
    },
    {
      path: '/smart-recommendation',
      name: 'SmartRecommendation',
      component: SmartRecommendation,
      meta: {
        title: 'Đề xuất thông minh',
        authorities: []
      },
    },
    {
      path: '/settings',
      name: 'SettingsLayout',
      component: SettingsLayout,
      redirect: '/settings/profile',
      meta: {
        isLogin: true,
        authorities: [Authority.USER, Authority.STAFF, Authority.ADMIN]
      },
      children: [
        {
          path: 'profile',
          name: 'SettingsProfile',
          component: UserEdit,
          meta: {
            title: 'Cập nhật thông tin',
            isLogin: true
          }
        },
        {
          path: 'security',
          name: 'SecuritySettings',
          component: SecuritySettings,
          meta: {
            title: 'Bảo mật & Đăng nhập',
            isLogin: true
          }
        },
        {
          path: 'preferences',
          name: 'SettingsPreferences',
          component: SearchPreferences,
          meta: {
            title: 'Cá nhân hóa tìm kiếm',
            isLogin: true
          }
        }
      ]
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: 'Trang chủ',
        authorities: [],
      },
    },
    {
      path: '/search',
      name: 'Search',
      component: Home,
      meta: {
        title: 'Kết quả tìm kiếm',
        authorities: [],
      },
    },
    {
      path: '/author/:id',
      name: 'AuthorBooks',
      component: AuthorDetail,
      meta: {
        title: 'Tác giả',
        authorities: [],
      },
    },
    {
      path: '/category/:id',
      name: 'CategoryBooks',
      component: CategoryDetail,
      meta: {
        title: 'Thể loại sách',
        authorities: [],
      },
    },
    {
      path: '/trending',
      name: 'Trending',
      component: Home,
      meta: {
        title: 'Sách thịnh hành',
        authorities: [],
      },
    },
    {
      path: '/book/:id',
      name: 'BookDetail',
      component: BookDetail,
      meta: {
        authorities: [],
        title: 'Chi tiết sách',
      },
    },
    {
      path: '/my-bookcase',
      name: 'ReadingProgress',
      component: ReadingProgress,
      meta: {
        isLogin: true,
        title: 'Tủ sách của tôi',
        authorities: [Authority.USER, Authority.STAFF, Authority.ADMIN]
      },
    },
    {
      path: '/book-suggest',
      name: 'BookSuggest',
      component: BookSuggest,
      meta: {
        isLogin: true,
        title: 'Đề xuất sách',
        authorities: [Authority.USER, Authority.STAFF, Authority.ADMIN]
      },
    },
    {
      path: '/old-books',
      name: 'OldBookList',
      component: OldBookList,
      meta: {
        title: 'Sách cũ',
        authorities: []
      },
    },
    {
      path: '/my-old-books',
      name: 'MyOldBookList',
      component: MyOldBookList,
      meta: {
        isLogin: true,
        title: 'Quản lý sách cũ của tôi',
        authorities: [Authority.USER, Authority.STAFF, Authority.ADMIN]
      },
    },
    {
      path: '/old-books/create',
      name: 'OldBookForm',
      component: OldBookForm,
      meta: {
        isLogin: true,
        title: 'Đăng bán sách cũ',
        authorities: [Authority.USER, Authority.STAFF, Authority.ADMIN]
      },
    },
    {
      path: '/old-books/edit/:id',
      name: 'OldBookEdit',
      component: OldBookForm,
      meta: {
        isLogin: true,
        title: 'Chỉnh sửa bài đăng sách cũ',
        authorities: [Authority.USER, Authority.STAFF, Authority.ADMIN]
      },
    },
    {
      path: '/old-books/:id',
      name: 'OldBookDetail',
      component: OldBookDetail,
      meta: {
        title: 'Chi tiết sách cũ',
        authorities: []
      },
    },
    {
      path: '/old-books/book/:idBook',
      name: 'BookOldBooks',
      component: BookOldBooks,
      meta: {
        title: 'Sách cũ đang bán',
        authorities: []
      },
    },
    {
      path: '/info',
      name: 'Info',
      component: Info,
      meta: {
        title: 'Thông tin & Giới thiệu',
        authorities: []
      },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: NotFound,
      meta: {
        error: true,
        title: 'Trang không tồn tại',
        authorities: []
      },
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Forbidden,
      meta: {
        error: true,
        title: "Không có quyền truy cập trang",
        authorities: []
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
})


router.beforeEach((to, from, next) => {
  const isAuthenticated = checkAuthentication();
  const authority = getAuthority();

  const checkAuthority = authority.some(element => to.meta.authorities.includes(element)) || to.meta.authorities.length === 0;

  if (to.meta.error) {
    document.title = to.meta.title || 'Lối Đọc';
    return next("/");
  }

  // Nếu URL /search có query params (như ?key=...), chuyển hướng thẳng về trang chủ "/", không cho search qua URL query
  if (to.path === '/search' && to.query && (to.query.key !== undefined || to.query.keyword !== undefined)) {
    document.title = 'Lối Đọc';
    return next('/');
  }

  // Trang /info chỉ dành riêng cho thiết bị di động & tablet (iPhone, iPad: width < 992px)
  if (to.path === '/info') {
    if (typeof window !== 'undefined' && window.innerWidth >= 992) {
      return next('/');
    }
  }

  // Public page (no isLogin defined) - accessible to everyone
  if (to.meta.isLogin === undefined) {
    document.title = to.meta.title || 'Lối Đọc';
    return next();
  }

  if (to.meta.isLogin) {
    // Requires authentication
    if (isAuthenticated) {
      if (checkAuthority) {
        next();
      } else {
        next('/forbidden');
      }
    } else {
      next('/login');
    }
  } else {
    // Guest-only pages (login, register)
    if (!isAuthenticated) {
      next();
    } else {
      next('/');
    }
  }
  document.title = to.meta.title || 'Lối Đọc';
});

function checkAuthentication() {
  return localStorage.getItem("token") != null;
}

function getAuthority() {
  if (checkAuthentication()) {
    return JSON.parse(JSON.parse(localStorage.getItem('current-account')).authority);
  } else {
    return Array.from(Authority.GUEST);
  }
}

export default router
